import { Types } from 'mongoose';
import { IAccountOwned } from './account';

export interface ICoupon extends IAccountOwned {
  _id: Types.ObjectId;
  code: string;
  action: CouponAction;
  value: number;
  isLimited: boolean;
  usageCap: number;
  usageCount: number;
  isActive: boolean;
  expiresAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export enum CouponAction {
  PercentageDiscount = 'percentageDiscount',
  FixedDiscount = 'fixedDiscount',
  FreeShipping = 'freeShipping',
}
